// src/components/Toast/toast.js
// 🍞 API globale de toasts — utilisable n'importe où sans hook ni contexte.
//   import { toast } from '../../components/Toast/toast';
//   toast.success('Produit créé !');
//   toast.error(err.response?.data?.message || 'Erreur');
//   toast.info('Code envoyé sur WhatsApp');
//   toast.warning('Votre panier va expirer');
// Le ToastProvider (monté dans App.js) enregistre sa file ici au montage.

let pushFn = null;

export function registerToast(fn) {
  pushFn = fn;
}

const emit = (type, message, options = {}) => {
  if (typeof message !== 'string' || !message.trim()) return;
  if (pushFn) {
    pushFn({ type, message: message.trim(), duration: options.duration });
  } else {
    // Filet de sécurité : si le provider n'est pas monté (ex. très tôt),
    // on retombe sur la console plutôt que de perdre le message.
    console.warn('[toast] provider non monté:', type, message);
  }
};

export const toast = {
  success: (message, options) => emit('success', message, options),
  error: (message, options) => emit('error', message, options),
  info: (message , options) => emit('info', message, options),
  warning: (message, options) => emit('warning', message, options),
};
